"use client";

import { useState } from "react";
import { INITIAL_FORM_DATA } from "@/app/calculator/constants/types";
import { canProceed } from "@/app/calculator/utils/calculatorUtils";
import { TOTAL_STEPS } from "@/app/calculator/constants/calculatorData";

/**
 * useCalculator — manages step navigation and form state
 * for the multi-step business setup calculator.
 */
export function useCalculator() {
  const [step, setStep]   = useState(1);
  const [data, setData]   = useState(INITIAL_FORM_DATA);

  /** Update a single field */
  const update = (key, value) =>
    setData((prev) => ({ ...prev, [key]: value }));

  /** Go to next step if allowed */
  const next = () => {
    if (canProceed(step, data) && step < TOTAL_STEPS) {
      setStep((s) => s + 1);
    }
  };

  /** Go back one step */
  const back = () => setStep((s) => Math.max(1, s - 1));

  /** Reset everything */
  const reset = () => {
    setStep(1);
    setData(INITIAL_FORM_DATA);
  };

  return {
    step,
    data,
    update,
    next,
    back,
    reset,
    isValid: canProceed(step, data),
    isLast:  step === TOTAL_STEPS,
    isFirst: step === 1,
  };
}
